import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
    useAddTransportTypeMutation,
    useDeleteTransportTypeMutation,
    useEditTransportTypeMutation
} from "../../../../redux/api/handBooksApi/transportTypesApi";
import { EntTypeTransport } from "../../../../models/handBooks/typeTransport";
import { getCookie } from "typescript-cookie";

const useTypeTransport = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addTypeTransport] = useAddTransportTypeMutation();
    const [deleteTypeTransport] = useDeleteTransportTypeMutation();
    const [editTypeTransport] = useEditTransportTypeMutation();
    async function onAddTypeTransport(newTypeTransport: EntTypeTransport): Promise<boolean> {
        try {
            let status: boolean = false;
            await addTypeTransport(newTypeTransport).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteTypeTransport(typeTransport: EntTypeTransport) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTypeTransport(typeTransport.id).then((response: any) => {
                         if (response.error) {
                                                     const isKyrgyz = getCookie('i18next') === 'ky';
                                                     const lang = isKyrgyz ? 'kg' : 'ru';
                                                     const res = response.error.data?.res;
                                                     const errorMessages = Array.isArray(res)
                                                         ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                         : response.error.data?.msg || t('unknownError'); 
                                                     throw new Error(errorMessages);
                                                 }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditTypeTransport(editedTypeTransport: EntTypeTransport): Promise<boolean> {
        try {
            let status: boolean = false;
            await editTypeTransport(editedTypeTransport).then((response: any) => {
                 if (response.error) {
                                             const isKyrgyz = getCookie('i18next') === 'ky';
                                             const lang = isKyrgyz ? 'kg' : 'ru';
                                             const res = response.error.data?.res;
                                             const errorMessages = Array.isArray(res)
                                                 ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                 : response.error.data?.msg || t('unknownError'); 
                                             throw new Error(errorMessages);
                                         }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddTypeTransport,onDeleteTypeTransport, onEditTypeTransport }

}
export { useTypeTransport };

